export default __webpack_public_path__ + "static/media/number_document_logo.793996e2.svg";